import { FinalVisualizationBuilder } from '../../../../app/configurator/VisualizationBuilder';
import type { ShoppingCartItemData } from '../../../../app/data/model';
import ConfigurationImage from '../../../../app/shared/components/ConfigurationImage';
import { CartItemDetails } from '../../../cart/CartItem/CartItemDetails/CartItemDetails';
import type { AddedToCartItemTranslation, CartItemPreviewTranslation } from '../../../localization/SiteTranslation';
import { CartItemSubtotal } from '../CartItemSubtotal/CartItemSubtotal';
import css from './AddedToCartItem.css';

interface AddedToCartItemProps {
  item: ShoppingCartItemData;
  translation: AddedToCartItemTranslation;
}

export const AddedToCartItem = ({ item, translation }: AddedToCartItemProps) => {
  return (
    <div>
      <p className={css.shoppingCartProductName}>{item.baseModel.name}</p>
      <CartItemPreview item={item} translation={translation.cartItemPreview} />
      <CartItemSubtotal totalPrice={item.totalPrice} translation={translation.cartItemSubtotal} />
    </div>
  );
};

interface CartItemPreviewProps {
  item: ShoppingCartItemData;
  translation: CartItemPreviewTranslation;
}

const CartItemPreview = ({ item, translation }: CartItemPreviewProps) => {
  return (
    <div className={css.shoppingCartDetails}>
      <ConfigurationImage
        configurationCodeOrigin={item.configurationCodeOrigin}
        className={css.shoppingCartDetailsImage}
        src={FinalVisualizationBuilder.buildUrl(item.code)}
        width={100}
        height={150}
        sharpeningFactor={2}
        scalingMode="fit"
      />
      <CartItemDetails
        code={item.code}
        quantity={item.quantity}
        listPrice={item.listPrice}
        salePrice={item.salePrice}
        className={css.shoppingCartDetailsItem}
        propertyClassNames={{
          labelClassName: css.shoppingCartDetailsConfigLabel,
          valueClassName: css.shoppingCartDetailsConfigValue,
        }}
        translation={translation.cartItemDetails}
      />
    </div>
  );
};
